import { Divider, Row, Spin, Tabs } from 'antd';
import classNames from 'classnames/bind';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import historyBookingAPI from '~/api/HistoryBooking';
import { SVGS } from '~/assets/assetsPath';
import ItemBooking from '~/components/ItemBooking';
import CardAboutMe from '../../components/card-about-me';
import styles from './HistoryBooking.module.scss';
import { logEvent } from 'firebase/analytics';
import { analytics } from '~/service/firebase';
import { useNavigate } from 'react-router';
import { LeftOutlined } from '@ant-design/icons';
import config from '~/config';

const cx = classNames.bind(styles);
const { TabPane } = Tabs;

const TabsContainer = styled.div`
    .ant-tabs-tab {
        font-size: 16px;
        font-weight: 600;
        color: rgba(137, 137, 137, 1);
    }
    .ant-tabs-tab.ant-tabs-tab-active {
        border-bottom: 3px solid #311d4f !important;
        z-index: 2;
    }
    .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
        color: #311d4f;
    }
    .ant-tabs > .ant-tabs-nav,
    .ant-tabs > div > .ant-tabs-nav {
        margin: 0px 30px;
        @media screen and (max-width: 480px) {
            margin: 0px 10px;
        }
    }
    .ant-tabs-bottom > .ant-tabs-nav:before,
    .ant-tabs-bottom > div > .ant-tabs-nav:before,
    .ant-tabs-top > .ant-tabs-nav:before,
    .ant-tabs-top > div > .ant-tabs-nav:before {
        border-bottom: 3px solid #e2e2e2;
    }
`;

// const SearchComponent = styled.div`
//     margin: 20px 30px;
//     .ant-input-search-with-button .ant-input-group .ant-input {
//         height: 44px;
//     }
//     .ant-input-search-button {
//         height: 44px;
//     }
//     .ant-btn-primary {
//         background: #311d4f;
//     }
//     @media screen and (max-width: 480px) {
//         margin: 20px 10px;
//     }
// `;

const HistoryBooking = () => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [listHistoryBooking, setListHistoryBooking] = useState([]);

    const [pagination, setPagination] = useState({
        page: 1,
        limit: 10,
        total_item: 0,
        total_page: 0,
    });

    const activeKeyHistoryBooking = localStorage.getItem('activeKeyHistoryBooking');

    const [activeKey, setActiveKey] = useState(activeKeyHistoryBooking || 'ALL');

    const onChangeTabs = (key) => {
        localStorage.setItem('activeKeyHistoryBooking', key);
        setPagination({
            page: 1,
            limit: 10,
            total_item: 0,
            total_page: 0,
        });
        setActiveKey(key);
        handleGetListHistoryBooking([], 1, key);
    };

    const handleGetListHistoryBooking = async (list, page, type) => {
        try {
            setIsLoading(true);
            let historyBookings = list;
            let final = [];
            let filter = null;
            if (type === 'ALL') {
                filter = null;
            }
            if (type === 'WAITING') {
                filter = '{"activity":"WAITING"}';
            }
            if (type === 'PROCESSING') {
                filter = '{"activity":"PROCESSING"}';
            }
            if (type === 'ASSIGNED') {
                filter = '{"activity": {"$in": ["ASSIGNED", "CONFIRMED"]}}';
            }
            if (type === 'COMPLETED') {
                filter = '{"activity":"COMPLETED"}';
            }
            if (type === 'CANCELED') {
                filter = '{"activity":"CANCELED"}';
            }
            const params = {
                fields: '["$all", {"branch": ["$all"]}, {"booking_details": ["$all", {"service": ["$all", {"unit": ["$all"]}]}, {"combo_service": ["$all","$paranoid"]}]}]',
                filter: filter,
                order: '[["created_at", "DESC"]]',
                limit: pagination.limit,
                page: page,
            };
            const res = await historyBookingAPI.getListHistoryBookingAPI(params);

            if (res.code === 200) {
                historyBookings.push(...res.results.objects.rows);
                setPagination({
                    ...pagination,
                    page: page,
                    total_item: res.results.objects.count,
                    total_page: Math.ceil(res.results.objects.count / pagination.limit),
                });
            }
            if (historyBookings?.length) {
                final = [...new Map(historyBookings.map((item) => [item['id'], item])).values()];
            }

            setListHistoryBooking(final);
            setIsLoading(false);
        } catch (err) {
            console.log(err);
        }
    };
    const handleSeeMore = () => {
        try {
            const nextPage = pagination.page + 1;
            handleGetListHistoryBooking(listHistoryBooking, nextPage);
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        handleGetListHistoryBooking(listHistoryBooking, pagination.page, activeKey);
        //eslint-disable-next-line
    }, []);

    useEffect(() => {
        logEvent(analytics, 'VBeauty_Web_TrangLichSuDatLich');
        // eslint-disable-next-line
    }, []);

    return (
        <div className={cx('wrapper')}>
            <div className={cx('container')}>
                <div className={cx('left_section')}>
                    <div className={cx('left_wrapper')}>
                        <div className={cx('left_container')}>
                            <Row>
                                <CardAboutMe tabIndex={{ parent: 4, children: null }} />
                            </Row>
                        </div>
                    </div>
                </div>
                <div className={cx('title_header')}>
                    <Row className={cx('title_header_row')}>
                        <p className={cx('title')}>
                            <LeftOutlined
                                onClick={() => navigate(config.routes.personalPage)}
                                className={cx('btn_back')}
                            />{' '}
                            Booking history
                        </p>
                    </Row>
                </div>
                <div className={cx('right_section')}>
                    <div className={cx('right_container')}>
                        <TabsContainer>
                            <Tabs defaultActiveKey={activeKey} onChange={onChangeTabs}>
                                <TabPane tab="All" key="ALL">
                                    {isLoading ? (
                                        <Row justify="center" className={cx('spin')}>
                                            <Spin />
                                        </Row>
                                    ) : (
                                        <Content listHistoryBooking={listHistoryBooking} />
                                    )}
                                </TabPane>
                                <TabPane tab="Waiting for confirmation" key="WAITING">
                                    {isLoading ? (
                                        <Row justify="center" className={cx('spin')}>
                                            <Spin />
                                        </Row>
                                    ) : (
                                        <Content listHistoryBooking={listHistoryBooking} />
                                    )}
                                </TabPane>
                                <TabPane tab="Confirmed" key="PROCESSING">
                                    {isLoading ? (
                                        <Row justify="center" className={cx('spin')}>
                                            <Spin />
                                        </Row>
                                    ) : (
                                        <Content listHistoryBooking={listHistoryBooking} />
                                    )}
                                </TabPane>
                                <TabPane tab="Processing" key="ASSIGNED">
                                    {isLoading ? (
                                        <Row justify="center" className={cx('spin')}>
                                            <Spin />
                                        </Row>
                                    ) : (
                                        <Content listHistoryBooking={listHistoryBooking} />
                                    )}
                                </TabPane>
                                <TabPane tab="Completed" key="COMPLETED">
                                    {isLoading ? (
                                        <Row justify="center" className={cx('spin')}>
                                            <Spin />
                                        </Row>
                                    ) : (
                                        <Content listHistoryBooking={listHistoryBooking} />
                                    )}
                                </TabPane>
                                <TabPane tab="Cancelled" key="CANCELED">
                                    {isLoading ? (
                                        <Row justify="center" className={cx('spin')}>
                                            <Spin />
                                        </Row>
                                    ) : (
                                        <Content listHistoryBooking={listHistoryBooking} />
                                    )}
                                </TabPane>
                            </Tabs>

                            {pagination?.page < pagination?.total_page && (
                                <Row justify="center" style={{ marginTop: '30px' }}>
                                    {/* <Divider style={{ borderTop: '10px solid rgba(0,0,0,.06)' }} /> */}
                                    <div className={cx('btn_see_more')} onClick={handleSeeMore}>
                                        see more
                                    </div>
                                </Row>
                            )}
                        </TabsContainer>
                    </div>
                </div>
            </div>
        </div>
    );
};

const Content = ({ listHistoryBooking }) => {
    return (
        <div>
            {/* <SearchComponent>
                <Search placeholder="Search for booking" enterButton />
            </SearchComponent> */}
            <Divider style={{ borderTop: '10px solid rgba(0,0,0,.06)' }} />
            {listHistoryBooking?.length ? (
                listHistoryBooking?.map((item, index) => {
                    return <ItemBooking item={item} key={index} />;
                })
            ) : (
                <>
                    {/* <Divider style={{ borderTop: '10px solid rgba(0,0,0,.06)' }} /> */}
                    <div className={cx('no_service')}>
                        <img src={SVGS.IconNoService} alt="" />
                        <span>No bookings yet</span>
                    </div>
                </>
            )}
        </div>
    );
};

export default HistoryBooking;
